<div class="new-package-wizard">
  @if (activeStep === 'select-package-source') {
    <div class="select-package-source-step">
      <div class="chooser">
        <p-button color="accent" data-testing-id="upload-package-button" class="custom-label large-button" label="Upload App" (click)="openStep('upload-package'); $event.stopPropagation();">
          <fa-icon icon="upload"></fa-icon>
        </p-button>
        <span class="or-label">or</span>
        <p-button color="accent" class="large-button custom-label" label="Connect to Repository" (click)="openStep('connect-package-repo'); $event.stopPropagation();">
          <fa-icon icon="link"></fa-icon>
        </p-button>
      </div>
    </div>
  }
  @if (activeStep === 'upload-package') {
    <div class="upload-package-step upload">
      <div class="upload-wrapper">
        @if (!uiInProgress) {
          <div class="upload-dndarea" wmtDragDrop (filesDropped)="dropFiles($event)">
            <span class="upload-dnd-label">Drag & Drop a File here</span>
            <span class="upload-dnd-label small">or</span>
            <div class="upload-chooser">
              <input hidden type="file" class="upload-filechooser" id="fileInput" [accept]="acceptedAppFileExtensions" (change)="selectFile($event)">
              <label #fileLabel for="fileInput">
                <button pButton class="p-button-secondary" (click)="fileLabel.click()">Select a file from disk</button>
              </label>
            </div>
          </div>
        }
        @if (uiInProgress) {
          <div class="upload-dndarea disabled">
            <span class="upload-dnd-label disabled">Uploading ...</span>
          </div>
        }
        @if (loadedFile) {
          <div class="upload-file-entry">
            <div class="name">
              {{loadedFile.file.name}}
            </div>
            <div class="size">
              {{(loadedFile.file.size / (1024 * 1024)).toFixed(2)}} MB
            </div>
            @if (uiInProgress) {
              <div class="icon passive">
                <fa-icon icon="sync-alt" animation="spin" [fixedWidth]="true"></fa-icon>
              </div>
            }
          </div>
        }
        <div class="wizard-actions">
          @if (!uiInProgress) {
            <p-button class="action-button custom-label" color="accent" label="Upload" [disabled]="!loadedFile" (click)="upload($event)">
              <fa-icon icon="upload"></fa-icon>
            </p-button>
          }
          @if (uiInProgress) {
            <p-button class="action-button custom-label" color="accent" label="Upload" [disabled]="true">
              <fa-icon icon="cog" animation="spin"></fa-icon>
            </p-button>
          }
          <button pButton data-testing-id="cancel-upload-button" class="p-button-text" (click)="cancelWizard()">Cancel</button>
        </div>
      </div>
    </div>
  }
  @if (activeStep === 'connect-package-repo') {
    <div class="connect-package-repo-step">
      <div class="repo-type-chooser">
        <div class="form">
          <div class="form-section" [ngClass]="{'last-section': !pkgSrcConfigForm}">
            <div class="form-section-info">
              <h4>Repository Type</h4>
              <div class="description">Choose where webmate retrieves the package from.</div>
            </div>
            <div class="form-section-content">
              <div class="form-item">
                <div class="form-item-content">
                  <div class="repo-type appcenter" [ngClass]="{'active': pkgSrcConfigForm?.get('repositoryType')?.value === 'appcenter'}" (click)="initializePackageRepoForm('appcenter');">
                    <img src="../../../../../assets/img/appcenter.svg" alt="MS App Center" aria-label="MS App Center"/>
                    <label>MS AppCenter</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (!!pkgSrcConfigForm && pkgSrcConfigForm.get('repositoryType')?.value === 'appcenter') {
            <form [formGroup]="pkgSrcConfigForm" class="form">
              <div class="form-section">
                <div class="form-section-info">
                  <h4>Authentication</h4>
                  <div class="description">Credentials used by webmate to access your AppCenter repository.</div>
                </div>
                <div class="form-section-content">
                  <div class="form-item">
                    <h4 class="form-label">API Key
                      <fa-icon icon="question-circle" pTooltip="You may use a user or app API key here."></fa-icon>
                    </h4>
                    <div class="form-item-content">
                      <div class="form-item-input"><input type="password" class="ui-state-error ui-inputtext" size="60"
                        [ngClass]="{'ui-state-error': !pkgSrcConfigForm.get('apiKey').valid}" pInputText formControlName="apiKey">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-section">
                <div class="form-section-info">
                  <h4>App Selection</h4>
                  <div class="description">Configure the App webmate tries to download.</div>
                </div>
                <div class="form-section-content">
                  <div class="form-item">
                    <h4 class="form-label">Owner</h4>
                    <div class="form-item-content">
                      <div class="form-item-input"><input type="text" class="ui-state-error ui-inputtext" size="60"
                        [ngClass]="{'ui-state-error': !pkgSrcConfigForm.get('owner').valid}" pInputText formControlName="owner">
                      </div>
                    </div>
                  </div>
                  <div class="form-item">
                    <h4 class="form-label">App Name</h4>
                    <div class="form-item-content">
                      <div class="form-item-input"><input type="text" class="ui-state-error ui-inputtext" size="60"
                        [ngClass]="{'ui-state-error': !pkgSrcConfigForm.get('appName').valid}" pInputText formControlName="appName">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-section">
                <div class="form-section-info">
                  <h4>Artifact Selection</h4>
                  <div class="description">Configure the build artifact to be retrieved.</div>
                </div>
                <div class="form-section-content">
                  <div class="form-item">
                    <div class="form-item-content">
                      <div class="form-item-input">
                        <p-selectButton formControlName="wantsBuildArtifact" [options]="[{label: 'Release', value: false}, {label: 'Latest Build', value: true}]"></p-selectButton>
                      </div>
                    </div>
                  </div>
                  @if (pkgSrcConfigForm.get('wantsBuildArtifact')?.value) {
                    <div class="form-item">
                      <h4 class="form-label">Branch</h4>
                      <div class="form-item-content">
                        <div class="form-item-input"><input type="text" class="ui-state-error ui-inputtext" size="60"
                          [ngClass]="{'ui-state-error': !pkgSrcConfigForm.get('branch')?.valid}" pInputText formControlName="branch">
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div>
                <div class="actions-wrapper">
                  <div class="wizard-actions">
                    <div class="test-button-wrapper">
                      @if (latestPackageSourceConfigTestResult) {
                        <div class="test-button-overlay" [ngClass]="{'success': latestPackageSourceConfigTestResultSuccessful, 'failure': !latestPackageSourceConfigTestResultSuccessful}">
                          <label>{{latestPackageSourceConfigTestResult}}</label></div>
                        }
                        @if (!testInProgress) {
                          <p-button class="action-button custom-label" label="Test" [disabled]="pkgSrcConfigForm.invalid" (click)="testPackageSourceConfig($event)">
                            <fa-icon icon="question-circle"></fa-icon>
                          </p-button>
                        }
                        @if (testInProgress) {
                          <p-button class="action-button custom-label" label="Test" [disabled]="true">
                            <fa-icon icon="cog" animation="spin"></fa-icon>
                          </p-button>
                        }
                      </div>
                      @if (!uiInProgress) {
                        <p-button class="action-button custom-label" label="Connect Repository" [disabled]="pkgSrcConfigForm.invalid" (click)="savePackageWithPackageSourceConfig($event)">
                          <fa-icon icon="save"></fa-icon>
                        </p-button>
                      }
                      @if (uiInProgress) {
                        <p-button class="action-button custom-label" label="Connect Repository" [disabled]="true">
                          <fa-icon icon="cog" animation="spin"></fa-icon>
                        </p-button>
                      }
                      <div class="cancel-button" (click)="cancelWizard()">Cancel</div>
                    </div>
                  </div>
                </div>
              </form>
            }
          </div>
        </div>
      </div>
    }
  </div>
